<template>

    <div class="filter">

        <span class="filter__text">
            {{i18n.showProjects}}:
        </span>

        <div class="filter__wrap">

            <span v-if="all" class="filter__trigger" @click="toggleListFilter">
                {{i18n.all}}
            </span>
            <span v-else class="filter__trigger" @click="toggleListFilter">
                {{i18n.filter}}: {{yearsActiveToString}}
            </span>

            <div class="filter__list-wrap">

                <ul class="filter__list" :class="{'filter__list--xs-visible': filterXsVisible}">
                    <li class="filter__item" v-for="year in yearsFiltered">
                        <input class="filter__input" type="checkbox"
                               :name="year.year"
                               :id="year.year"
                               v-model="year.active"
                               v-on:change="triggerRouteChange"
                        >
                        <label class="filter__label" :for="year.year">
                            {{year.year}} {{i18n.year}}
                        </label>
                    </li>
                    <li class="filter__item">
                        <input class="filter__input" type="checkbox"
                               name="all"
                               id="all"
                               v-model="all"
                               :disabled="all"
                        >
                        <label class="filter__label" for="all">
                            {{i18n.showAll}}
                        </label>
                    </li>
                </ul>

            </div> <!-- /.filter__list-wrap-->

        </div> <!-- /.filter__wrap-->

    </div> <!-- /.filter-->

</template>

<script>
    export default {
        name: 'list-filter',
        props: {
            years: {
                type: Array,
                default: []
            },
            yearsFilter: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                yearsFiltered: [],
                filterXsVisible: false,
                all: true,
                i18n: window.WP.i18n // a variable registered with wp_localize_script()
            }
        },
        computed: {
            yearsActiveToString() {
                return this.getActiveYears().join(', ');
            }
        },
        methods: {
            toggleListFilter() {
                this.filterXsVisible = !this.filterXsVisible;
            },
            getActiveYears() {
                return this.yearsFiltered
                    .map(({ active, year }) => active ? year : false)
                    .filter(year => year !== false)
            },
            triggerRouteChange() {
                const years = this.getActiveYears();

                this.$router.push({
                    name: 'project-category',
                    params: {
                        yearsFilter: years.join(',')
                    }
                });
            },
            filterYears() {
                let activeItems = 0;

                this.yearsFiltered = this.years
                    .map(year => {
                        const active = this.yearsFilter.indexOf(year) !== -1;
                        if (active) {
                            activeItems++;
                        }
                        return {
                            active,
                            year,
                        }
                    })
                    .sort((a, b) => Number(b.year) - Number(a.year));

                this.all = activeItems === 0;
            },
            deselectAllYears() {
                if (this.all !== true) {
                    return;
                }
                this.yearsFiltered.forEach(year => {
                    year.active = false;
                });
                this.triggerRouteChange();
            }
        },
        watch: {
            years: 'filterYears',
            yearsFilter: 'filterYears',
            all: 'deselectAllYears'
        }
    }
</script>



// WEBPACK FOOTER //
// list-filter.vue?8f4a1ad4